var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHiphop = function SvgHiphop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hiphop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 7.75c-3.728 0-6.75 2.014-6.75 4.5v4.5L7 19c0 2.9 4.701 5.25 10.5 5.25l7.5-6v-6c0-2.486-3.022-4.5-6.75-4.5Zm1.5 4.012v6.415c-.492.046-.993.073-1.498.073h-.001c-.506 0-1.007-.027-1.501-.074v-6.414c0-.845.529-1.903 1.437-2.51l.063-.002.063.001c.908.608 1.437 1.666 1.437 2.511ZM13 12.25c0-1.014 1.106-2.108 2.864-2.651-.393.68-.614 1.434-.614 2.163v6.192a12.068 12.068 0 0 1-2.25-.653V12.25Zm10.5 5.05c-.677.28-1.443.495-2.25.655v-6.193c0-.729-.221-1.484-.614-2.163 1.758.543 2.864 1.636 2.864 2.651v5.05Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hiphop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgHiphop;